import React from 'react';
import { connect } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import { navigate } from "gatsby";
import { EventCell } from '../../';
import style from './style.module.scss';
import ButtonPrimary from '../../ButtonPrimary';

const EventsSection = props => {
    const { loading, events } = props;

    return (
        !loading ?
            <>
                <section className={`${style.eventsSection}`}>
                    <span className={`${style.eventSectionCTAHeader}`}>EVENTS</span>
                    <div className={`${style.carouselWrapper}`}>
                        {
                            events.length > 3 ? <Carousel
                                centerMode={true}
                                centerSlidePercentage={10}
                                className={style.carousel}
                                showThumbs={false}
                                showArrows={false}
                                infiniteLoop={true}
                                autoPlay={true}
                                stopOnHover={false}
                                showStatus={false}
                                interval={3000}
                            > {
                                    events.map((e) => (
                                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
                                            <EventCell {...events[0]} />
                                        </div>
                                    ))
                                }

                            </Carousel> :
                                <>
                                    {
                                        events.map(e => (
                                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
                                                <EventCell {...events[0]} />
                                            </div>
                                        ))
                                    }
                                </>
                        }

                    </div>
                    {/* <Bounce>
                        {events[0] && <EventCell {...events[0]} />}
                    </Bounce> */}
                    {/* <Bounce>
                        <div className={style.eventItem}>
                            <span className={style.eventSectionCTAHeader}>EVENTS</span>
                            {events.length > 2 &&
                                <ButtonPrimary
                                    label="SEE MORE EVENTS"
                                    color="#5EC438"
                                    background="#FFFFFF"
                                    type="neutral"
                                    size="medium"
                                    onClick={() => navigate('/events')}>
                                </ButtonPrimary>
                            }
                        </div>
                    </Bounce> */}
                    {/* <Bounce>
                        {events[1] && <EventCell {...events[1]} />}
                    </Bounce> */}
                    <div className={`${style.eventItem} ${style.seeMoreBottom}`}>
                        <ButtonPrimary
                            label="SEE MORE EVENTS"
                            color="#5EC438"
                            background="#FFFFFF"
                            type="neutral"
                            size="medium"
                            onClick={() => navigate('/events')}>
                        </ButtonPrimary>
                    </div>
                </section>
                <section>
                    <div className={style.socialMediaSectionHeader}>
                        <span>@BimboPuertoRico</span>

                        <span className={style.mediaCopy}>
                            Follow us on Facebook, Instagram, and Twitter.
                            Make sure to tag us and use #saborbimbo for a chance to get featured!
                    </span>
                    </div>
                </section>
            </> : <span>Loading...</span>
    );
};

EventsSection.propTypes = {

};

export default connect(state => ({
    loading: state.getEventsLoading,
    events: state.events
}))(EventsSection);